<template>
  <div>
    <el-dialog class="labelDialog" :visible="visible" title="选择标签" width="700px" :before-close="handleClose">
       <div>
            <div class="checked_all"><el-checkbox v-model="checkedAll" @change="toCheckAll" :indeterminate="isSelect">全选</el-checkbox></div>
            <div style="border-bottom: 1px solid #EFEFEF;padding-bottom: 20px">
                <el-checkbox-group v-model="labecheckList" @change="oneTabBtn">
                  <el-checkbox v-for="(item, index) in labelListData" :label="item.id" :key="index" style="margin-bottom: 6px">
                    {{item.labelName}}
                  </el-checkbox>
                </el-checkbox-group>

                <!-- <div
                    class="left-small-item"
                    v-for="(item,index) in labelListData"
                    :key="index"
                    @click="oneTabBtn(item,index,labelListData)"
                    :style="{'border-color': item.state ? changeColor : '','color': item.state ? changeColor : ''}"
                >
                    <p class="widthP">{{item.labelName}}</p>
                    <img v-if="item.state" class="right-gou" src="../assets/images/right.png" alt>
                </div> -->
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取消</el-button>
            <el-button type="primary" @click="sureBtn">保存标签</el-button>
        </span>
    </el-dialog>
    
  </div>
</template>


<script>
import {getBuyerLabel} from "@/api/buyerLabel.js";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: 'buyer-label-dialog',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    checkedArr:{
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: true,
      checkedAll: false,
      isSelect: false, // 全选，选择部分状态
      labelListData: [],
      labecheckList: [],
    }
  },
  mounted() {
    if (this.data[0]) {
      this.data[0] = Number(this.data[0]);
    }
    this.labecheckList = this.data;
   
    getBuyerLabel().then(res => {
      if (res.code == '1') {
        this.labelListData = res.data;
      } 
    })
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  methods: {
    sureBtn() {
      this.$emit('onClose', true, this.labecheckList)
    },
    handleClose() {
      this.$emit('onClose', false)
    },
    toCheckAll(val){
      let that = this;
      if(val == true){
        var ids = [];
        this.labelListData.forEach((item,index) => {
           ids.push(item.id); 
        }); 
        this.labecheckList = ids;
        this.isSelect = false;
      } else if(val == false){
        var idList = [];
        // this.labelListData.forEach((item,index) => {
        //     item.state = val;
        // }); 
        this.isSelect = false;
        this.labecheckList = [];
      }
    },
    oneTabBtn(){
      // let that = this;
      // let newObj = this.labelListData[index];
      // newObj.state = !newObj.state;
      // Vue.set(this.labelListData,index,newObj);

    

      // this.labelListData.forEach(item => {
      //   if(item.state === true){
      //     selectCount = selectCount + 1;
      //   }
      // });
      
      let selectCount = this.labecheckList.length;
      if(selectCount >0 && selectCount<this.labelListData.length){
        this.checkedAll = false;
        this.isSelect = true;
      } else if (selectCount == this.labelListData.length){
        this.checkedAll = true;
        this.isSelect = false;
      } 
      else {
        this.checkedAll = false;
        this.isSelect = false;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
   .labelDialog .el-dialog{
        // height: 450px;
        .el-dialog__body{
            height: 330px;
            overflow: auto;
            background: #fff;
        }
        .el-dialog__footer{
            text-align: center;
            // .cancel_Btn{
            //     width: 96px;
            //     height: 36px;
            //     border-radius: 6px;
            //     border: 1px solid rgba(153,153,153,1);
            //     font-size: 16px;
            //     font-family: PingFangSC-Regular;
            //     font-weight: 400;
            //     color: rgba(102,102,102,1);
            // }
            // .sure_Btn{
            //     width: 96px;
            //     height: 36px;
            //     // background: rgba(32,98,231,1);
            //     border-radius: 6px;
            //     font-size: 16px;
            //     font-family: PingFangSC-Regular;
            //     font-weight: 400;
            //     // color: rgba(255,255,255,1);
            // }

        }
    }
    .checked_all{
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51,51,51,1);
        line-height: 20px;
        margin-bottom: 16px;
    }
    .create_btn{
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        line-height: 20px;
        // margin: 24px 0px;
        margin: 24px 0px 0px 0px;
    }
</style>
